import {UnItem} from "../../shared/models/un-item";
import {DropdownFilterType} from "../interfaces/dropdown-filter-type";
import {Moment} from "moment";
import * as moment from 'moment';

export class SlickFilterItem implements UnItem {
    constructor(id: number, selected: boolean, public name: string, public rowType: DropdownFilterType){
        this.id = id;
        this.selected = selected;
        this.position = 0;
        this.value = '';
    }

    public id: number;
    public selected: boolean;
    public position: number;
    public value: string | Moment;

    public clone = (): SlickFilterItem => {
        let item = new SlickFilterItem(
            this.id,
            this.selected,
            this.name,
            this.rowType);
        item.position = this.position;
        item.value = moment.isMoment(this.value) ? this.value.clone() : this.value;
        return item;
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/slick-filter-item.ts